import { createPortal } from "react-dom";
import scss from "./PageLoadingBar.module.scss";

const PageLoadingBar = ({ color = "var(--primary-color)", fullScreen = true }) => {
    const indicator = (
        <div className={fullScreen ? scss.screen : scss.topOnly}>
            <div className={scss.bar} role="progressbar" aria-label="Učitavanje stranice" style={{ "--loading-color": color }} />
        </div>
    );

    return fullScreen ? indicator : createPortal(indicator, document.body);
};

export default PageLoadingBar;
